import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { ICrearIncidente } from "../../../../../Interfaces/hazard/IHazard";
import { GrupoIncidenteService } from "../../../../../services/hazard/grupoIncidente";

export const UsePanelNuevoIncidente=(props:IOpenPanel)=>{
    const [disableForm, setDisableForm] = useState<boolean>(true);
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const [request,setRequest]=useState<ICrearIncidente>({nombreIncidente:""})
    const reset=()=>{
        setMensaje("")
        setRequest({nombreIncidente:""})
        setStatus(0)
        props.onDismiss()
    }
    const required: (keyof ICrearIncidente)[] = [
        "nombreIncidente",
      ];
    useEffect(()=>{
        const check = required.every((field) => {
            const value = request[field];
            return value !== null && value !== undefined && value !== "";
          });
        setDisableForm(!check)
    },[request])
    const postInsertarIncidente=()=>{
        setLoading(true)
        GrupoIncidenteService.CrearIncidente(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },
                3000)
                
            }else{
                setStatus(500)
                setMensaje("Error Inesperado");
            }
            setLoading(false)
           
        }).catch((e)=>{
              console.log('Error detallado:', e);
              setMensaje("Error Inesperado");
              setStatus(500);
              setLoading(false);
        })}
    return {request,setRequest,postInsertarIncidente,loading,disableForm,reset,mensaje,status}
}